/**
 * Placeholder for an amount that needs an input the estimate doesn't have yet.
 * @returns A muted dash with an accessible name.
 * @throws Never.
 */
export const DashCell = () => (
  <span className="text-gray-500" aria-label="Not available">
    –
  </span>
);
